/**
 * @fileoverview Documents › Library — the document management interface.
 *
 * URL: /dashboard/jobs/:jobId/gather
 */

import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { GatherView } from "@/components/jobs/phases/gather/GatherView";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/gather/",
)({
  component: GatherLibrary,
});

function GatherLibrary() {
  const { jobId } = Route.useParams();
  return <GatherView jobId={jobId as Id<"jobs">} />;
}
